import { render, staticRenderFns } from "./DfSolutions.vue?vue&type=template&id=12b0c4da&"
import script from "./DfSolutions.vue?vue&type=script&lang=js&"
export * from "./DfSolutions.vue?vue&type=script&lang=js&"
import style0 from "./DfSolutions.vue?vue&type=style&index=0&id=12b0c4da&prod&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports